module.exports = __webpack_public_path__ + "static/media/DarkFae3.0aba0fce.png";